import React, { createContext, useEffect } from 'react'

import { ILivePageProps } from 'plugin-codaf-risk-ext-bowtie/types'

import { themeAwardWidgetDecorator } from '../utils'
import { BOWTIE_SETTINGS_URL } from '../utils/constants'
import { BowtieSettings } from './BowtieSettings'

export type IQueryParamsTabs = 'diagrams' | 'barriers' | 'bowties'

export interface IQueryParamsList {
    type: 'list'
    tab?: IQueryParamsTabs
    perPage?: number
    page?: number
    orderBy?: string
    direction?: 'ASC' | 'DESC'
    filterBy?: number
    keyword?: string
    operation?: string
    asset?: string
    [x: string]: string | number
}

export interface IQueryParamsEdit {
    type: 'edit'
    tab?: IQueryParamsTabs
    id?: number
    aux?: IQueryParamsTabs
    auxId?: number
}

export interface IBowtieSettingsRouteContext<P extends IQueryParamsList | IQueryParamsEdit> {
    params: P
    setParams: (newParams: IQueryParamsList | IQueryParamsEdit) => void
}

const defaultParams: IQueryParamsList | IQueryParamsEdit = {
    type: 'list',
    tab: 'diagrams',
    page: 1,
    perPage: 50,
    direction: 'ASC',
    orderBy: 'ID'
}
function toQueryString(obj: IQueryParamsList | IQueryParamsEdit): string {
    const vet = ['string', 'number', 'boolean']
    const vet2 = ['undefined', 'null']

    return Object.keys(obj)
        .filter(key => vet.includes(typeof obj[key]))
        .map(key => (!vet2.includes(typeof obj[key]) ? `${key}=${obj[key]}` : undefined))
        .filter(e => e)
        .join('&')
}
export function setParams(params: IQueryParamsList | IQueryParamsEdit): void {
    window.location.href = `/#/config/${BOWTIE_SETTINGS_URL}?${toQueryString(params)}`
}

export const BowtieSettingsRouteContext = createContext({
    params: defaultParams,
    setParams
} as IBowtieSettingsRouteContext<any>) // eslint-disable-line prettier/prettier, @typescript-eslint/no-explicit-any

const BowtieSettingsWrapper: React.FC<ILivePageProps<IQueryParamsList | IQueryParamsEdit>> = ({ id: params }) => {
    useEffect(() => {
        if (!params || !params.type || !params.tab || (params.type === 'edit' && !params.id)) {
            setParams({ ...defaultParams, tab: params?.tab ?? defaultParams.tab })
        } else {
            if (params.type === 'list') {
                setParams({ ...defaultParams, ...params })
            }
        }
    }, [params])

    return (
        <BowtieSettingsRouteContext.Provider value={{ params: params ?? defaultParams, setParams }}>
            <BowtieSettings />
        </BowtieSettingsRouteContext.Provider>
    )
}

export default themeAwardWidgetDecorator(BowtieSettingsWrapper, ':root')
